import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import TakeOffIcon from '@/components/TakeOffIcon.vue'
import LandIcon from '@/components/LandIcon.vue'

Vue.use(Vuetify)

const opts = {
  icons: {
    values: {
      takeoff: {
        component: TakeOffIcon
      },
      land: {
        component: LandIcon
      },
    },
  },
}

export default new Vuetify(opts)
